import { Controller } from "@hotwired/stimulus"

// Counts visible dashboard items marked as exclusive (via data-exclusive-question="true")
// and updates the modal's count + noun + visibility on demand. Reads the DOM, so it naturally
// reflects any items the user removed in rearrange mode without a server round-trip.
export default class extends Controller {
  static targets = ["count", "noun", "label"]

  refresh() {
    const count = document.querySelectorAll('[data-item-id][data-exclusive-question="true"]').length
    if (this.hasCountTarget) this.countTarget.textContent = count
    if (this.hasNounTarget) this.nounTarget.textContent = count === 1 ? "question" : "questions"
    if (this.hasLabelTarget) this.labelTarget.hidden = count === 0
  }
}
